var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F7B100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H14C12.9 10 12 10.9 12 12V28C12 29.1 12.9 30 14 30H26C27.1 30 28 29.1 28 28V16L22 10ZM26 28H14V12H21V17H26V28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1698 21.6786C19.1788 21.3872 18.8601 21.086 18.8601 20.6169C18.8601 20.0786 19.301 19.7033 20.0389 19.7033C20.816 19.7033 21.1041 20.123 21.1303 20.7403H22.0952C22.0646 19.8909 21.6062 19.1107 20.6937 18.8588V17.7773H19.384V18.844C18.537 19.0514 17.8559 19.6736 17.8559 20.6267C17.8559 21.7675 18.6898 22.3354 19.9079 22.6662C20.9993 22.9625 21.2176 23.3971 21.2176 23.8564C21.2176 24.1971 21.0037 24.7403 20.0389 24.7403C19.1395 24.7403 18.7859 24.286 18.7378 23.7033H17.7773C17.8297 24.7848 18.5457 25.3922 19.384 25.5946V26.6662H20.6937V25.6045C21.5451 25.4218 22.2218 24.8638 22.2218 23.8514C22.2218 22.4489 21.1609 21.9699 20.1698 21.6786Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/InvoiceIcon.ed8fc13fd8bcd120b2480a8f8b552683.svg";
export { ForwardRef as ReactComponent };